import { NgModule } from '@angular/core'
import { NodeListItemComponent } from './node-list-item.component'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [NodeListItemComponent],
  declarations: [NodeListItemComponent]
})
export class NodeListItemModule {}
